module.exports = "/_next/static/images/ananthu-32a928e35ce6ebc53add3cfdb25b375e.png";